import { BANNER_CONSTANTS } from "@commoncore/constants/bannerConstants";
import { HTML_ERRORS } from "@commoncore/constants/htmlErrors";
import { TOAST } from "@commoncore/constants/ToastMessages";
import { LocalStorageProps } from "@commoncore/enums/localStorageProps";
import { ListViewImplementation } from "@commoncore/implementation/ListViewImplementation";
import { GlobalService } from "@commoncore/services/global.service";
import { AppEvents } from "@commoncore/utils/app-events";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { Subject } from "rxjs";
import { CloudBridgeConstants } from "../constants/CloudBridgeConstants";

export class IcloudBackupImpementation {
    public router: any;
    public http: any;
    public route: any;
    public universalService: any;
    static singleInstance:IcloudBackupImpementation;
    backupRootFolderKey:any;
    platformsList = [];
    localStorageSvc: any;
    listService: any;
    response:any;
    userData:any;
    transferNotInitiated:boolean = false;
    fileTransferStatus:any;
    transferList:any =[];
    selectedTransfer:any;
    customMetadata: any;
    listOfFilePresent: boolean = false;
    listImpl:any;
  transferFileList: any;
  cleverTapEventsService: any;
    ignoreBackUpsList = [];
    refreshBackups: Subject<object> = new Subject();
    cloudBridgeConstants: any;
  moreOptionsOpenedTransfer: any;
  
    constructor(public globalService: GlobalService) {
        this.setHandler(this.globalService);
        
    }

    public static getInstance(globalService):IcloudBackupImpementation{
        if(this.singleInstance == null){
            this.singleInstance = new IcloudBackupImpementation(globalService);
            return this.singleInstance;
        }else{
            return this.singleInstance;
        }
    }

    public setHandler(globalService) {
        this.router = globalService.getRouterRef();
        this.http = globalService.getHttpClientRef();
        this.universalService = globalService.getUniversalServiceRef();
        this.route = globalService.getActivatedRoute();
        this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
        this.listService = this.globalService.getListServiceRef();
        this.userData = this.localStorageSvc.getUserData(true);
        this.customMetadata = globalService.getCustomMetadataServiceRef();
        this.listImpl = ListViewImplementation.getInstance(globalService);
        this.cleverTapEventsService = globalService.getCleverTapEventsvc();
        this.cloudBridgeConstants = new CloudBridgeConstants();
        this.cloudBridgeConstants = this.cloudBridgeConstants["CLOUD_BRIDGE_BACKUP"];
    }
    
    async getTransferSummery(url){
        var self = this;
        return new Promise(function(resolve,reject){
            self.http.get(url).subscribe(
            suc=>{
                suc = self.updateStorageImagesAndIcons(suc);
                self.universalService.showLoader = false;
                self.openMoreOptionsDropDown();
                resolve(suc)
            },
            err=>{
                self.universalService.showLoader = false;
                console.log("getTransferSummery error",err);
                reject(err)
            }
        )
      })
    }

    iClouAuth(url,id,password){
        var self = this;
        let params  = {     
            "username": id,
            "password": password,
        }
      return new Promise(function(resolve,reject){
          self.http.post(url,params).subscribe(
              suc=>{
                  resolve({status:'success',res: suc})
              },
              err=>{
                  console.log("iClouAuth error",err);
                  reject(err)
              }
          )
      })
    }

    validate2FA(url,token){
        var self = this;
        let details = this.localStorageSvc.getLocalProperty(LocalStorageProps.APPLE_DETAILS,true)
        let params ={
            "username": details.username,
            "password": details.pwd,
            // "device_key":  this.userData["deviceKey"],
            "code": token
        }
        return new Promise(function(resolve,reject){
            self.http.post(url,params).subscribe(
                suc=>{
                    self.close2FaModal();
                    AppEvents.globalObservable.next({"otpverificationrequired":false});
                    resolve({status:'success'});
                },
                err=>{
                    console.log("validate2FA error",err);
                    self.showErrorMessageForValidating2FA(err);
                    reject(err)
                }
            )
        })
    }

    showErrorMessageForValidating2FA(err){
        let errorMessage = "";
        this.universalService.showLoader = false;
        if(err.error.code == 'ICL40007' || err.error.code == 'ICL50001'){
          
          errorMessage = HTML_ERRORS["INVALID_OTP"];
        }else if(err.error.code == "ICL40005" || err.error.code == "ICL40022" || err.error.code == "ICL40021"){
          errorMessage = 'Incorrect code entered.'
        }else if(err.error.code == 'ICL40020'){
          AppEvents.cloudBridgeObsevable.next({"trasferStatusIsIP":true});
          this.universalService.iCloudBackup = false;
        }else{
          errorMessage = TOAST["GENERIC_ERROR"];
          this.universalService.showToast(TOAST["GENERIC_ERROR"],"error")
        }

        if(errorMessage != ""){
          AppEvents.globalObservable.next({"otpverificationerror":true,"message":errorMessage})
        }
    }

    initializeTransfer(url){
        var self = this;
        let details = this.localStorageSvc.getLocalProperty(LocalStorageProps.APPLE_DETAILS,true)
        let params ={
            "username": details.username,
            "password": details.pwd
        }
        return new Promise(function(resolve,reject){
          self.http.post(url,params).subscribe(
              info=>{
                    resolve(info)
              },
              err=>{
                    console.log('initializeTransfer err',err);
                    reject(err)
              }
            )
        })
    }

    getTransferStatus(url){
        var self = this;
        return new Promise(function(resolve,reject){
            self.http.get(url).subscribe(
                suc=>{
                    resolve(suc)
                },
                err=>{
                    console.log("getTransferStatus error",err);
                    reject(err)
                }
            )
        })
    }

    getFileTransferStatus(url){
        var self = this;
        return new Promise(function(resolve,reject){
            self.http.get(url).subscribe(
                suc=>{
                    suc = self.updateStorageImagesAndIcons([suc]);
                    self.universalService.showLoader = false;
                    resolve(suc[0])
                },
                err=>{
                    self.universalService.showLoader = false;
                    console.log("getTransferStatus error",err);
                    reject(err)
                }
            )
        })
    }

    getiCloudFailedFiles(url){
      var self = this;
      return new Promise(function(resolve,reject){
          self.http.get(url).subscribe(
              suc=>{
                  self.universalService.showLoader = false;
                  resolve(suc)
              },
              err=>{
                  self.universalService.showLoader = false;
                  console.log("getTransferStatus error",err);
                  reject(err)
              }
          )
      })
  }

    fetchDummyResponse(){
        var self = this;
        return new Promise(function(resolve,reject){
          self.http.get('assets/JSON/mockResponse.json').subscribe(
            suc=>{
              self.response = suc["mockResponse"];
              resolve(suc);
            }
          )
        })
    }


    close2FaModal(){
        this.universalService.iCloudBackup = false;
        this.universalService.showLoader = false;
        this.universalService.disableModalBackdrop();
    }
    private units: Array<string> = ['B', 'KB', 'MB', 'GB', 'TB'];

    transform(value: any, decimal?: number): any {
      let unit = 0;
      let precision: number;
      while (value >= 1024 && unit < this.units.length - 1) {
          value /= 1024;
          unit++;
      }
      precision = unit === 0 ? 0 : decimal != null ? decimal : 2;
      if (value != null && value !== "") {
          value = value.toFixed(precision);
          if (value % 1 == 0) {
              value = Math.trunc(value);
          }
      }
      return value + ' ' + this.units[unit];
    }

    updateUIStatus(res) {
      let self = this;
  
      res = res.filter(item => item.backupStatus !== 'SI');
  
      res.forEach((transfer) => {
        switch (transfer.backupStatus) {
          case 'P': self.updateTransfer(transfer, 'paused', 'Account Sync Paused', 'We will no longer be able to initiate any future backup. Kindly resume backup from the options menu and try again.');
                    break;
          case 'D': self.updateTransfer(transfer, 'disconnected', 'Account Disconnected', 'We no longer have access to transfer files from your account. Kindly reauthenticate and try again');
                    break;
          case 'AT':
          case 'Q':
            self.updateTransfer(transfer, 'loading', 'Retrieving account information', 'Your transfer is in the queue. It will be picked shortly.');
              break;

          case 'MI':
          case 'MC':
          case 'W':
            if(transfer['storageType'] == 'GPHOTOS'){
              self.updateTransfer(transfer, 'loading', 'Compiling file information', 
              transfer.totalCount == 0 
              ? 'Account data is being processed...'
              : `${transfer.totalCount} file's data processed successfully`);
            }else{
              self.updateTransfer(transfer, 'loading', 'Compiling file information', 
              transfer.totalCount == 0 
              ? 'Account data is being processed...'
              : `${transfer.totalCount} file's data (${self.transform(transfer["totalSizeInBytes"],1)}) processed successfully`);
            }
              break;

          case 'DI':
          case 'DC':
          case 'UI':
          case 'I':
          case 'R':
              transfer.dataSize = Math.round(transfer["totalSizeInBytes"] / (1024 * 1024 * 1024));
              if (transfer.successCount == 0) {
                self.updateTransfer(transfer, 'loading', 'Scheduling data transfer shortly', '');
                  transfer.percentage = 0;
                  transfer.subText = self.getSubTextForDataSize(transfer.dataSize);
              } else {
                  transfer.statusDescription = 'Transfer in progress...';
                  transfer.statusIcon = 'inprogress';
                  transfer.percentage = Math.round((transfer.successCount / transfer.totalCount) * 100);
                  transfer.subText = `${transfer.successCount} of ${transfer.totalCount} files transferred`;
                  transfer.subText1 = self.getSubTextForDataSize(transfer.dataSize);
              }
              break;

          case 'PS':
            self.updateTransfer(transfer, 'loading', 'Transfer in queue', `${transfer.successCount} of ${transfer.totalCount} files transferred`);
              break;

          case 'MP':
            self. updateTransfer(transfer, 'error', 'Something went wrong', "We're restarting the process. Please wait a moment...");
              break;

          case 'UC':
          case 'C':
            transfer['storageType'] == 'GPHOTOS'?
              self.updateTransfer(transfer, 'complete', 'Transfer complete', `${transfer.successCount} files transferred`): self.updateTransfer(transfer, 'complete', 'Transfer complete', `${transfer.successCount} files (${self.transform(transfer["successSizeInBytes"],1)}) transferred`);
              break;

          case 'AF':
          case 'QE':
          case 'UF':
          case 'F':
          case 'E':
          case 'U':
          case 'DF':
            self.handleTransferFailure(transfer);
              break;

          case 'PR':
            self.updateTransfer(transfer, 'error', 'Transfer failed', "Transfer initiation failed due to insufficient permissions. Please write to us at care.jioaicloud@jio.com.");
              break;

          case 'IP':
              self.updateTransfer(transfer, 'error', 'Transfer failed', "Transfer initiation failed due to insufficient permissions. Please reverify your iCloud settings on your Apple device and try again.");
              break;

          case 'MF':
              self.updateTransfer(transfer, 'error', 'Transfer failed', "Sorry, something went wrong. Please write to us at care.jioaicloud@jio.com.");
              break;

          case 'PD':
              self.updateTransfer(transfer, 'error', 'Transfer failed', "Transfer failed due to changes in iCloud password or permissions. Please write to us at care.jioaicloud@jio.com ");
              break;
            
          case 'PM':
              self.updateTransfer(transfer, 'error', 'Transfer failed', "Transfer failed due to changes in iCloud password or permissions. Please re-authenticate and grant the necessary permissions to resume.");
              break;
        }
      });
      setTimeout(() => {
          if (!self.selectedTransfer) return;
  
          let found = self.transferList.find(tr => self.selectedTransfer.sourceEmailId == tr.sourceEmailId);
          if (found) {
              let index = self.transferList.indexOf(found);
              if (index >= 0) {
                  let el = document.querySelector('.progressCont_' + index);
                  let accordianIconEl = document.querySelector('#heading_' + index + ' .icon');
                  if (el && accordianIconEl) {
                      accordianIconEl.classList.replace('NeueDropdown_Inactive', 'NeueDropdown_Active');
                      if (el.classList.contains('NeueDropdown_Inactive')) {
                          accordianIconEl.classList.replace('NeueDropdown_Inactive', 'NeueDropdown_Active');
                      }
                  }
              }
          }
      }, 0);

      self.transferList = res;
      self.transferNotInitiated = self.transferList.length >= 1? true :false;
      return self.transferList;   
    }
    updateTransfer(transfer, statusIcon, status, subText,errorCause?) {
      transfer.statusIcon = statusIcon;
      transfer.statusDescription = status;
      transfer.subText = subText;
      if(errorCause){
        transfer.errorCause = errorCause
      }
    }
    getSubTextForDataSize(dataSize) {
        if(dataSize < 20){
            return "Transfer may take few hours to complete. Please be patient. We will email you with progress updates soon."
        }else if (dataSize >= 20 && dataSize < 100) {
            return "Your transfer may take up to 24 hours. Please be patient. We will email progress updates, or you can return to this page for the latest status.";
        } else if (dataSize >= 100 && dataSize < 200) {
            return "Your transfer may take up to 48 hours. Please be patient. We will email progress updates, or you can return to this page for the latest status.";
        } else if (dataSize >= 200 && dataSize < 300) {
            return "Your transfer may take up to 72 hours. Please be patient. We will email progress updates, or you can return to this page for the latest status.";
        } else if(dataSize >= 300){
            return "The transfer may take few days to complete. Please be patient. We will email you with progress updates soon.";
        }
    }
    handleTransferFailure(transfer) {

      if (transfer.successCount == 0) {
         if(transfer.backupStatus == 'QE' || transfer.backupStatus == 'E' || transfer.backupStatus == 'U'){
          this.updateTransfer(transfer, 'error', 'Transfer failed', `${transfer.successCount} of ${transfer.totalCount} files transferred` ,this.getFailureSubText(transfer));
         }else if(transfer.backupStatus == 'AF'){
          this.updateTransfer(transfer, 'error', 'Transfer failed', "Please re-authenticate and grant the necessary permissions to resume the transfer." ,this.getFailureSubText(transfer));
         }else{
          this.updateTransfer(transfer, 'error', 'Transfer failed', `${transfer.successCount} of ${transfer.totalCount} files transferred`);
         }
      } else if (transfer.successCount > 0 && transfer.successCount <= transfer.totalCount) {
            if(transfer.backupStatus == 'QE' || transfer.backupStatus == 'E' || transfer.backupStatus == 'U'){
                this.updateTransfer(transfer, 'error', 'Transfer failed', `${transfer.successCount} of ${transfer.totalCount} files transferred` ,this.getFailureSubText(transfer));
            }else if(transfer.backupStatus == 'AF'){
              this.updateTransfer(transfer, 'error', 'Transfer failed', "Please re-authenticate and grant the necessary permissions to resume the transfer." ,this.getFailureSubText(transfer));
            }else{
                this.updateTransfer(transfer, 'warning', 'Transfer partially complete', `${transfer.successCount} of ${transfer.totalCount} files transferred`);
            }
      }
    }

    getFailureSubText(transfer) {
      if (transfer.backupStatus == 'QE' || transfer.backupStatus == 'U') {
          return ' (JioAICloud storage full)';
      } else if (transfer.backupStatus == 'AF' || transfer.backupStatus == 'E') {
          return ' (Authentication failed)';
      } else {
          return '';
      }
    }
    async updateStatusUI(transfer){
      let self = this;
      const statusMap = {
        'AT': { statusIcon: 'loading', statusTxt: 'Retrieving account information' },
        'Q': { statusIcon: 'loading', statusTxt: 'Retrieving account information' },
        'P': { statusIcon: 'paused', statusTxt: 'Account Sync Paused' },
        'D': { statusIcon: 'disconnected', statusTxt: 'Account Disconnected'},
        'MI': { statusIcon: 'loading', statusTxt: 'Compiling file information' },
        'MC': { statusIcon: 'loading', statusTxt: 'Compiling file information' },
        'W': { statusIcon: 'loading', statusTxt: 'Compiling file information' },
        'DI': transfer.successCount === 0 
                ? { statusIcon: 'loading', percentage: 0, statusTxt: 'Scheduling data transfer shortly' }
                : { statusIcon: 'inprogress', statusTxt: 'Transfer in progress...', percentage: Math.round((transfer.successCount / transfer.totalCount) * 100) },
        'DC': transfer.successCount === 0 
                ? { statusIcon: 'loading', percentage: 0, statusTxt: 'Scheduling data transfer shortly' }
                : { statusIcon: 'inprogress', statusTxt: 'Transfer in progress...', percentage: Math.round((transfer.successCount / transfer.totalCount) * 100) },
        'UI': transfer.successCount === 0 
                ? { statusIcon: 'loading', percentage: 0, statusTxt: 'Scheduling data transfer shortly' }
                : { statusIcon: 'inprogress', statusTxt: 'Transfer in progress...', percentage: Math.round((transfer.successCount / transfer.totalCount) * 100) },
        'I': transfer.successCount === 0 
                ? { statusIcon: 'loading', percentage: 0, statusTxt: 'Scheduling data transfer shortly' }
                : { statusIcon: 'inprogress', statusTxt: 'Transfer in progress...', percentage: Math.round((transfer.successCount / transfer.totalCount) * 100) },
        'R': transfer.successCount === 0 
                ? { statusIcon: 'loading', percentage: 0, statusTxt: 'Scheduling data transfer shortly' }
                : { statusIcon: 'inprogress', statusTxt: 'Transfer in progress...', percentage: Math.round((transfer.successCount / transfer.totalCount) * 100) },
        'PS': { statusIcon: 'loading', statusTxt: 'Transfer in queue' },
        'MP': { statusIcon: 'error', statusTxt: 'Something went wrong' },
        'UC': {
            statusIcon: 'complete',
            statusTxt: transfer.duplicateFilesCount > 0 
                        ? `Transfer complete (${transfer.duplicateFilesCount} duplicate${transfer.duplicateFilesCount > 1 ? 's' : ''} found)` 
                        : 'Transfer complete'
        },
        'C': {
            statusIcon: 'complete',
            statusTxt: transfer.duplicateFilesCount > 0 
                        ? `Transfer complete (${transfer.duplicateFilesCount} duplicate${transfer.duplicateFilesCount > 1 ? 's' : ''} found)` 
                        : 'Transfer complete'
        },
        'AF': {
            statusIcon: 'error', 
            statusTxt: 'Transfer failed',
            errorCause: ' (Authentication failed)'
        },
        'E': {
            statusIcon: 'error', 
            statusTxt: 'Transfer failed',
            errorCause: ' (Authentication failed)'
        },
        'QE': {
            statusIcon: 'error', 
            statusTxt: 'Transfer failed',
            errorCause: ' (JioAICloud storage full)'
        },
        'U': {
            statusIcon: 'error', 
            statusTxt: 'Transfer failed',
            errorCause: ' (JioAICloud storage full)'
        },
        'UF': {
            statusIcon: 'error',
            statusTxt: transfer.successCount === 0 
                        ? 'Transfer failed' 
                        : transfer.duplicateFilesCount > 0 
                            ? `Transfer partially complete (${transfer.duplicateFilesCount} duplicate${transfer.duplicateFilesCount > 1 ? 's' : ''} found)` 
                            : 'Transfer partially complete'
        },
        'DF': {
          statusIcon: 'error',
          statusTxt: transfer.successCount === 0 
                      ? 'Transfer failed' 
                      : transfer.duplicateFilesCount > 0 
                          ? `Transfer partially complete (${transfer.duplicateFilesCount} duplicate${transfer.duplicateFilesCount > 1 ? 's' : ''} found)` 
                          : 'Transfer partially complete'
        },
        'F': {
            statusIcon: 'error',
            statusTxt: transfer.successCount === 0 
                        ? 'Transfer failed' 
                        : transfer.duplicateFilesCount > 0 
                            ? `Transfer partially complete (${transfer.duplicateFilesCount} duplicate${transfer.duplicateFilesCount > 1 ? 's' : ''} found)` 
                            : 'Transfer partially complete'
        },
        'PR': { statusIcon: 'error', statusTxt: 'Transfer failed' },
        'IP': { statusIcon: 'error', statusTxt: 'Transfer failed' },
        'MF': { statusIcon: 'error', statusTxt: 'Transfer failed' },
        'PD': { statusIcon: 'error', statusTxt: 'Transfer failed' },
        'PM': { statusIcon: 'error', statusTxt: 'Transfer failed' },
      };
      if (statusMap[transfer["backupStatus"]]) {
        Object.assign(transfer, statusMap[transfer["backupStatus"]]);
      }
      self.fileTransferStatus = transfer;
      return self.fileTransferStatus;
      
    }

    getFolderMetadata(url){
      var self = this;
      return new Promise(function(resolve,reject){
        self.http.get(url).subscribe(
          suc=>{
            var objMetadata = self.customMetadata.segregateData({"objects":[suc]},"allfiles")
            self.universalService.showLoader = false;
            resolve({"metadata":objMetadata[0]});
          },
          err=>{
            console.log("error from folder metadata API",err);
            self.universalService.showLoader = false;
            reject({"metadata":undefined});
          }
        )
      })
    }

    async updateStatusFileListUi(){
      let self = this;

      if (self.fileTransferStatus["latestFiles"].length > 0) {
          self.listOfFilePresent = true;

          self.fileTransferStatus["latestFiles"].forEach(file => {
              file.status = self.getFileStatus(file["jcProcessingStatus"]);
              file.extension = self.getFileExtension(file["sourceObjectName"]);

              if (self.universalService.isMobileDevice) {
                  file.objectShortName = self.getShortName(file["sourceObjectName"], 10);
              } else {
                  file.objectShortName = self.getShortName(file["sourceObjectName"], 30);
              }
          });
          await self.calculateSizes();
          self.renderFileStatusList();
      } else {
          self.listOfFilePresent = false;
      }
    }
    getFileStatus(status) {
      switch (status) {
        case 'DC':
        case 'R':
            return 'Uploading..';
        case 'I':
            return 'Uploading..';
        case 'C':
            return 'Completed';
        case 'N':
            return 'In queue…';
        default:
            return '';
      }
    }

    getFileExtension(fileName) {
      const index = fileName.lastIndexOf(".");
      return index > 0 ? fileName.slice(index) : "";
    }

    getShortName(fileName, maxLength) {
      if (fileName.length > maxLength) {
          const ext = this.getFileExtension(fileName);
          return `${fileName.slice(0, maxLength - ext.length - 3)}...${ext}`;
      } else {
          return fileName;
      }
    }

    calculateSizes() {
      let self = this;
      self.fileTransferStatus["latestFiles"].forEach(object => {
          const sizeInBytes = parseInt(object["sourceSizeInBytes"]);
          object["objectSize"] = sizeInBytes == null || sizeInBytes == undefined 
            ? "-" 
            : self.transform(sizeInBytes);
      });
    }

    renderFileStatusList(){
      setTimeout(()=>{
        let self = this;
        let obj=[{"objectName":"jhg","size":"20gb","status":"in-progress"}]
        self.transferFileList = self.fileTransferStatus["latestFiles"];
        self.listImpl.decideListOptions('icloudBackup');
        self.listImpl.fetchiCloudBackupStatusListView(self.transferFileList)
      },100)    
    }

    updateUserStorage(accountsList){
        let account = accountsList.find(acc=> (acc["usedSpace"] != undefined && acc["usedSpace"] != null)); // added this line just to avoid issues when any account does not have used space info
        let usedSpace = account["usedSpace"];
        if(usedSpace || usedSpace == 0) {
          var userData = this.localStorageSvc.getUserData(true);
          if(userData && userData["quota"]){
              usedSpace =  usedSpace == 0 ? 0 : ( usedSpace ?  usedSpace : userData["quota"]["totalUsedQuota"]);
              userData["quota"]["totalUsedQuota"] =  usedSpace;
              AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
              AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
          }
        }
        this.userData = userData;
    }

    updateStorageImagesAndIcons(accountsList){
        let updatedAccountList = [];
        accountsList.map((acc,index)=>{
            acc["accIndex"] = index;
            let findStorageType = this.platformsList.find(pltfrm => pltfrm["storageType"] == acc["storageType"]);
            if(findStorageType){
                acc["image"] = findStorageType["image"];
                acc["storageName"] = findStorageType["name"];
                acc["backupStatus"] = (acc["status"] == 'D' || acc["status"] == 'P') ? acc["status"] : acc["backupStatus"]
                // acc["providerIcon"] = findStorageType["providerIcon"];
            }
            if(!this.ignoreBackUpsList.includes(acc["storageType"])){
              updatedAccountList.push(acc);
            }
        })
        return updatedAccountList;
    }

    fetchAllTheProviders(){
        var self = this;
        return new Promise(function(resolve,reject){
          self.http.get(ENV_CONFIG.jsonUrls.cloudplatformUrls).subscribe(
            suc=>{
              self.platformsList = suc["service-providers"];
              self.updatePlatformDisplayStatus();
              resolve(suc);
            }
          )
        })
      }
    
      updatePlatformDisplayStatus(){
        let data;
        if(this.universalService.inAppWebViewOpened){
          data = this.localStorageSvc.getLocalProperty('nativeHeaders',true);
        }else{
          data = this.localStorageSvc.getUserData(true);
        }
        this.platformsList.forEach(platform => {
          let thirdPartyBackUp = data["thirdPartyBackup"] ? data["thirdPartyBackup"] : {"enableTPB":"D"};
          let isThirdPartyBackUpEnabled = thirdPartyBackUp["enableTPB"] == "Y"
          if (platform.storageType === 'GPHOTOS') {
            platform.status = (isThirdPartyBackUpEnabled && thirdPartyBackUp["enableGP"] == "Y") ? "Y" : "D";
          } else if (platform.storageType === 'GDRIVE') {
            platform.status = (isThirdPartyBackUpEnabled && thirdPartyBackUp["enableGD"] == "Y") ? "Y" : "D";
          } else if (platform.storageType === 'DROPBOX') {
            platform.status = (isThirdPartyBackUpEnabled && thirdPartyBackUp["enableDB"] == "Y") ? "Y" : "D";
          } else if (platform.storageType === 'ICLOUD') {
            platform.status = data["thirdPartyBackup"]["enableICD"] ? data["thirdPartyBackup"]["enableICD"] : "D";
          } else if (platform.storageType === 'IPHOTOS') {
            platform.status = data["thirdPartyBackup"]["enableICP"] ? data["thirdPartyBackup"]["enableICP"] : "D";
          }
          if(platform.status != "Y"){
            this.ignoreBackUpsList.push(platform["storageType"]);
          }
          if(window.location.href.includes('/ioscloudbridge') && platform.storageType != 'IPHOTOS'){
            this.ignoreBackUpsList.push(platform["storageType"]);
            platform.status = 'N'
          }
        });
      }


      startUserAccountBackup(url,authCode,providerType){
        var self = this;
        var payload = {
          "authorizationCode":authCode,
          "storageType":providerType
        }
        return new Promise(function(resolve,reject){
          self.http.post(url,payload).subscribe(
            suc=>{
              resolve({started:true,resp:suc});
            },
            err=>{
              console.log("error from account list API",err);
              reject({started:false,resp:err});
            }
          )
        })
      }
  
      pauseBackup(url,account,state){
        var self = this;
        var payload = {
          "storageType":account["storageType"],
          "emailId":account["sourceEmailId"]
        }
        return new Promise(function(resolve,reject){
          self.http.put(url,payload).subscribe(
            suc=>{
              self.universalService.showLoader = false;
              // self.updateTransferStatusInTransferList(suc);
              resolve(
                { 
                  resp:"SUCCESS",
                  "storageType":account["storageType"],
                  "emailId":account["sourceEmailId"],
                  "backupStatus":suc.backupStatus,
                  "statusDescription":suc.statusDescription,
                  "nextBackup":suc.nextBackup,
                  "status":suc.status
                });
            },
            err=>{
              let msg = ""
              if(state == "pause"){
                msg = self.cloudBridgeConstants["TOASTS"]["TOGGLE_DISABLE_ERROR"];
              }else if(state == "resume"){
                msg = self.cloudBridgeConstants["TOASTS"]["TOGGLE_ENABLE_ERROR"];
              }
              msg = msg.replace("_storageType",account["storageType"]);
              msg = msg.replace("_emailid",account["sourceEmailId"]);
              self.universalService.showToast(msg,"error");
              console.log("error from pause API",err);
              self.universalService.showLoader = false;
              reject({paused:false,resp:err});
            }
          )
        })
      }
  
      disconnectBackup(url,account){
        var self = this;
        var payload = {
          "storageType":account["storageType"],
          "emailId":account["sourceEmailId"],
        }
        return new Promise(function(resolve,reject){
          self.http.put(url,payload).subscribe(
            suc=>{
              self.universalService.showLoader = false;
              // self.updateTransferStatusInTransferList(suc);
              resolve({disconnected:true,resp:suc});
            },
            err=>{
              console.log("error from diconnect account",err);
              self.universalService.showLoader = false;
              let msg= self.cloudBridgeConstants["TOASTS"]["DISCONNECT_ERROR"];
              msg = msg.replace("_storageType",account["storageType"]);
              msg = msg.replace("_emailid",account["sourceEmailId"])
              self.universalService.showToast(msg,"error");
              reject({disconnected:false,resp:err});
            }
          )
        })
      }

      retryBackup(url,account){
        var self = this;
        var payload = {
          "storageType":account["storageType"],
          "emailId":account["sourceEmailId"]
        }
        return new Promise(function(resolve,reject){
          self.http.post(url,payload).subscribe(
            suc=>{
              self.universalService.showLoader = false;
              resolve({retry:true,resp:suc});
            },
            err=>{
              console.log("error from pause API",err);
              self.universalService.showLoader = false;
              let msg= self.cloudBridgeConstants["TOASTS"]["RETRY_ERROR"];
              msg = msg.replace("_storageType",account["storageType"]);
              msg = msg.replace("_emailid",account["sourceEmailId"])
              self.universalService.showToast(msg,"error");
              reject({retry:false,resp:err});
            }
          )
        })
      }

      registerUser(url,storageType){
        var self = this;
        self.linkAccount(storageType)
        return new Promise(function(resolve,reject){
          self.http.get(url).subscribe(
            suc=>{
              self.universalService.showLoader = false;
              resolve({register:true,resp:suc});
            },
            err=>{
              console.log("error from account list API",err);
              self.universalService.showLoader = false;
              reject({register:false,resp:err});
            }
          )
        })
      }

      async linkAccount(storageType){
        if(storageType == 'GPHOTOS'){
          this.cleverTapEventsService.thirdPartyBackupCard('gphotos')
        }else if(storageType == 'GDRIVE'){
          this.cleverTapEventsService.thirdPartyBackupCard('gdrive');
        }else if(storageType == 'DROPBOX'){
          this.cleverTapEventsService.thirdPartyBackupCard('dropbox');
        }
        this.localStorageSvc.setStorageProviderType(storageType)
      }


      async updateTransferStatusInTransferList(suc){
        let findTransfer = this.transferList.find(transfer=> (transfer["storageType"] == suc["storageType"] && transfer["sourceEmailId"] == suc["sourceEmailId"]));
        if(findTransfer){
          let index = this.transferFileList.indexOf(findTransfer);
          if(index>=0){
            this.transferFileList[index] = {
              ...this.transferFileList[index],
              ...findTransfer
            }
            this.transferFileList[index]["backupStatus"] = (suc["status"] == 'D' || suc["status"] == 'P') ? suc["status"] : suc["backupStatus"];
            await this.updateUserStorage(this.transferFileList);
            await this.updateUIStatus(this.transferFileList)
          }
        }
      }


      saveSelectedTransferToOpenDotMenu(transfer){
        var dropdownId = "dropdown_menu_" + transfer?.storageType + "_" + transfer?.sourceEmailId;
        this.onscrollDropDownHandling(dropdownId)
        setTimeout(() => {
          let dropdownIsOpen = document.getElementById(dropdownId).classList.contains("show");
          if(dropdownIsOpen){
            this.moreOptionsOpenedTransfer = transfer;
          }else{
            this.moreOptionsOpenedTransfer = null;
          }
        }, 100);
        
      }
    
      onscrollDropDownHandling(dropdownId){
        setTimeout(()=>{
          var ParentTop = document.querySelector('.main-cloud-bridge-cont').getBoundingClientRect().top
          var topOffset = document.getElementById(dropdownId).getBoundingClientRect().top
          var relativeOffset = topOffset - ParentTop
          var windowHeight =  (document.querySelector('.main-cloud-bridge-cont')as any).offsetHeight;
          if (relativeOffset > (windowHeight -200)) {
            document.getElementById(dropdownId).classList.add('reverse');
          } else {
            document.getElementById(dropdownId).classList.remove('reverse');
          }
        },250)
            
      }
    
      openMoreOptionsDropDown(){
        if(!this.moreOptionsOpenedTransfer) return;
        setTimeout(() => {
          let id = this.moreOptionsOpenedTransfer["accIndex"];
          $("#more_options_" + id).trigger('click');
        });
      }


      resetMoreOptions(){
        this.moreOptionsOpenedTransfer = null;
      }

      resyncIcloudBackup(url){
        var self = this;
        return new Promise(function(resolve,reject){
          self.http.put(url).subscribe(
            suc=>{
              self.universalService.showLoader = false;
              resolve({status:'success',res: suc})
            },
            err=>{
                self.universalService.showLoader = false;
                console.log("resyncIcloudBackup error",err);
                reject(err)
            }
          )
        })
      }

      checkSameStorageTypeTransferIsInProgress(storageType){
        const validStatuses = ['MI', 'MC', 'DI', 'DC', 'UI', 'I','R', 'AT', 'PS', 'MP', 'Q', 'W', 'AT'];
        const storageNames = {
          IPHOTOS: "iCloud Photos",
          ICLOUD: "iCloud Drive",
          DROPBOX: "DropBox",
          GDRIVE: "Google Drive",
          GPHOTOS: "Google Photos"
        };
        const conflictingTransfers = this.transferList.filter(item => 
          validStatuses.includes(item.backupStatus) && item.storageType == storageType
        );

        if (conflictingTransfers.length > 0) {
          const storageName = storageNames[storageType];
          const msg = 'Transfer in progress for ' + storageName + '. Please try again once the transfer is complete.';
          this.universalService.showToast(msg, "error");
          return { status: 'inprogress'};
        }
        return {status: 'not-inprogress'};
        
      }
}


